import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { getSelectedMover, updateSelectedMover } from "@/store/mover/slice";
import { useUpdateMoverMutation } from "@/store/mover/apis";
import { useToast } from "@/hooks/use-toast";
import { Textarea } from "@/components/ui/textarea";

interface SalesForm {
  sales_faqs: string;
}

const Sales: React.FC = () => {
  const dispatch = useDispatch();
  const { toast } = useToast();
  const selectedMover = useSelector(getSelectedMover);
  const [updateMoverApi] = useUpdateMoverMutation();

  const form = useForm<SalesForm>({
    defaultValues: {
      sales_faqs: selectedMover?.sales_faqs,
    },
  });

  const onSubmit = async (data: SalesForm) => {
    try {
      const updatedMover = await updateMoverApi({
        data: {
          sales_faqs: data.sales_faqs,
        },
      }).unwrap();

      dispatch(updateSelectedMover(updatedMover));

      toast({
        title: "Sales FAQs updated successfully",
        variant: "default",
      });
    } catch (error) {
      console.error(error);
      toast({
        title: "Failed to update Sales FAQs. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <div className="w-full lg:w-1/2 px-4 py-4 flex flex-col justify-start items-start gap-4">
          <h2 className="text-lg font-bold">{"Settings > Sales FAQs"}</h2>
          <FormField
            control={form.control}
            name="sales_faqs"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormLabel>Sales FAQs</FormLabel>
                <FormControl>
                  <Textarea
                    rows={10}
                    placeholder="Enter sales FAQs and policies for your sales team to use."
                    autoComplete="off"
                    {...field}
                    className="w-full"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button type="submit">Save Changes</Button>
        </div>
      </form>
    </Form>
  );
};

export default Sales;
